import { Link } from "react-router-dom";
import heroImage from "../../assets/conveyancing-hero.jpg";

function Conveyancing() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section className="relative h-[80vh] flex items-center justify-center pt-24">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        ></div>

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-dancing-script">
            Conveyance & Real Estate
          </h1>

          <p className="mt-4 text-lg text-gray-200">
            
          </p>
        </div>

      </section>

      {/* ================= CONTENT ================= */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">

         <p className="text-gray-700 text-lg leading-relaxed">
  Conveyance and real estate law at <strong>GATI & CO. ADVOCATES</strong>
  is centered on protecting property rights, securing transactions,
  and ensuring that every investment is legally sound.
  Guided by our philosophy of <span className="italic">“Your property, legally bulletproof,”</span>
  we provide comprehensive legal support for individuals, businesses,
  developers, financial institutions, and investors involved in property transactions.
</p>

<p className="mt-6 text-gray-700 text-lg leading-relaxed">
  Our services include title due diligence through comprehensive searches
  at the Ministry of Lands to verify ownership, encumbrances, and legal status
  of property. We handle land transfers, leases, assignments, sub-leases,
  and drafting of sale agreements with precision and strict compliance with
  Kenyan property law. We also prepare mortgage and charge documentation
  for banks, SACCOs, and private lenders, ensuring that financing arrangements
  are secure and enforceable.
</p>

<p className="mt-6 text-gray-700 text-lg leading-relaxed">
  In addition, our firm advises on sectional properties, including unit title
  registration for apartments and commercial complexes, as well as stamp duty
  assessment and payment processes with the Kenya Revenue Authority.
  We also assist clients in securing Land Control Board consent and other
  mandatory approvals required for agricultural land transactions.
  Through every stage of the conveyancing process, we prioritize accuracy,
  risk reduction, and seamless execution to safeguard our clients’ property interests.
</p>

        </div>
      </section>

      {/* ================= NAV BUTTONS ================= */}
      <section className="py-12 px-6 bg-gray-100 border-t border-gray-200">
        <div className="max-w-7xl mx-auto flex justify-between items-center">

          {/* LEFT BUTTON */}
          <Link
            to="/services"
            className="px-6 py-3 border-2 border-[#0B3D91] text-[#0B3D91] bg-white rounded-lg font-semibold hover:bg-[#0B3D91] hover:text-white transition hover:-translate-x-1"
          >
            ← Back to practice areas
          </Link>

          {/* RIGHT BUTTON */}
          <Link
            to="/services/criminal"
            className="px-6 py-3 bg-[#0B3D91] text-white rounded-lg font-semibold hover:bg-blue-800 transition hover:translate-x-1"
          >
            Next Area →
          </Link>

        </div>
      </section>
    </>
  );
}

export default Conveyancing;